import { CartManager } from "./CartState"

/**
 * Global registry to store CartManager instances by region+channel key
 * This ensures we reuse the same instance across all components
 */
export const cartManagerRegistry = new Map<string, CartManager>()

/**
 * Gets or creates a CartManager instance for the given region and channel
 * @param region - The region identifier
 * @param channel - The channel identifier
 * @returns Shared CartManager instance
 */
export const getOrCreateCartManager = (
  region: string,
  channel: string
): CartManager => {
  const key = `${region}_${channel}`

  if (!cartManagerRegistry.has(key)) {
    cartManagerRegistry.set(key, new CartManager(region, channel))
  }

  return cartManagerRegistry.get(key)!
}
